import AppliedGiftCards from 'components/FrictionlessCheckout/PaymentReleaseFour/GiftCards/AppliedGiftCards/AppliedGiftCards';
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { orderSelector } from 'selectors/order/orderSelector';
import OrderUtils from 'utils/Order';
import checkoutApi from 'services/api/checkout';
import OrderActions from 'actions/OrderActions';
import decorators from 'utils/decorators';
import { INTERSTICE_DELAY_MS } from 'constants/Checkout';
import store from 'store/Store';
import ErrorsUtils from 'utils/Errors';
import Actions from 'Actions';
import FrictionlessCheckoutBindings from 'analytics/bindingMethods/pages/FrictionlessCheckout/FrictionlessCheckoutBindings';
import AppliedGiftCardsEN from 'components/FrictionlessCheckout/PaymentReleaseFour/GiftCards/AppliedGiftCards/locales/AppliedGiftCards_en_US';
import AppliedGiftCardsFR from 'components/FrictionlessCheckout/PaymentReleaseFour/GiftCards/AppliedGiftCards/locales/AppliedGiftCards_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(AppliedGiftCardsEN, AppliedGiftCardsFR);

const updateOrder = () => {
    checkoutApi
        .getOrderDetails(OrderUtils.getOrderId())
        .then(orderData => store.dispatch(OrderActions.updateOrder(orderData)))
        .catch(errorData => ErrorsUtils.collectAndValidateBackEndErrors(errorData, this));
};

const removeGiftCard = giftCard => {
    return () =>
        decorators
            .withInterstice(checkoutApi.removeGiftCard, INTERSTICE_DELAY_MS)(OrderUtils.getOrderId(), giftCard.paymentGroupId)
            .then(() => {
                FrictionlessCheckoutBindings.trackGiftCardRemoveConfirmation();
                updateOrder();
            })
            .catch(errorData => ErrorsUtils.collectAndValidateBackEndErrors(errorData, this));
};

const showInfoModal = (title, message, confirmButtonText, callback) => {
    store.dispatch(
        Actions.showInfoModal({
            isOpen: true,
            title: title,
            message: message,
            buttonText: confirmButtonText,
            callback: callback,
            cancelText: getText('cancel'),
            showCancelButtonLeft: true
        })
    );
};

const fields = createSelector(
    orderSelector,
    createStructuredSelector({
        giftCardLabel: getTextFromResource(getText, 'giftCardLabel'),
        hasBeenApplied: getTextFromResource(getText, 'hasBeenApplied'),
        applied: getTextFromResource(getText, 'applied'),
        removeLink: getTextFromResource(getText, 'removeLink'),
        removeGiftCardText: getTextFromResource(getText, 'removeGiftCardText'),
        areYouSureMessage: getTextFromResource(getText, 'areYouSureMessage')
    }),
    (order, textResources) => {
        const giftCardPaymentGroups =
            order?.orderDetails?.paymentGroups?.paymentGroupsEntries?.filter(
                group => group.paymentGroupType === OrderUtils.PAYMENT_GROUP_TYPE.GIFT_CARD
            ) || [];

        return {
            giftCardPaymentGroups,
            localization: textResources
        };
    }
);

const functions = {
    removeGiftCard,
    showInfoModal
};

const withAppliedGiftCardsProps = wrapHOC(connect(fields, functions));

export default withAppliedGiftCardsProps(AppliedGiftCards);
